import { Flex, Typography } from 'antd'

const { Paragraph, Title } = Typography

type Props = { title: string; subtitle?: string }

/** Big enough to open a step, small enough not to dwarf a 400px column. */
const TITLE_SIZE = 22

/**
 * Shared step heading. An `h1` for the serif the global `h1–h3` rule applies,
 * but sized down from the heading scale's own 28px. The subtitle is optional —
 * most steps say everything in the title.
 */
export const StepHeader = ({ title, subtitle }: Props) => (
  <Flex vertical gap={4}>
    <Title level={1} style={{ margin: 0, fontSize: TITLE_SIZE }}>
      {title}
    </Title>
    {subtitle ? (
      <Paragraph type="secondary" style={{ margin: 0 }}>
        {subtitle}
      </Paragraph>
    ) : null}
  </Flex>
)
